// let mobileButton = document.querySelector('.contactProject');
let projectBtn = document.querySelectorAll('.projectBtnContact');

let buttonTemporaire1 = document.querySelector('.contact-projet-1');
let buttonTemporaire2 = document.querySelector('.contact-projet-2');
let buttonTemporaire3 = document.querySelector('.contact-projet-3');
let buttonTemporaire4 = document.querySelector('.contact-projet-4');

projectBtn.forEach((element) => {
    element.addEventListener('click', function(e){
        e.preventDefault()

        if(element.classList.contains('active')){
            document.querySelector('.project__button').classList.remove('active');
            document.querySelector('.project__form').classList.remove('show');
            document.querySelector('.project').classList.remove('active');
            document.querySelector('.contactProject').classList.remove('active');
            document.querySelector('.menu__border').style.transform = 'translateX(0)';
            document.querySelector('.currentPage').classList.add('active');
            
        } else {
            document.querySelector('.project__button').classList.add('active');
            document.querySelector('.project__form').classList.add('show');
            document.querySelector('.project').classList.add('active');
        }

        if(document.querySelector('.header__navigation').classList.contains('active')){
            document.querySelector('.header__navigation').classList.remove('active');
            document.querySelector('.header__mobile-hamb').classList.remove('active');
            enableScroll()
        }

        if(document.querySelector('.menuPrincipalMobile').classList.contains('showMenu')){
            document.querySelector('.menuPrincipalMobile').classList.remove('showMenu');
            document.querySelector('.header__mobile-hamb').classList.remove('active');
            enableScroll()
        }
    })
});

// mobileButton.addEventListener('click', function(){

//     if(mobileButton.classList.contains('active')){
//         document.querySelector('.project__button').classList.remove('active');
//         document.querySelector('.project__form').classList.remove('show');
//         document.querySelector('.project').classList.remove('active');
//         mobileButton.classList.remove('active');
//         document.querySelector('.currentPage').classList.add('active');
//         document.querySelector('.menu__border').style.transform = 'translateX(0)';

//     } else {
//         document.querySelector('.project__button').classList.add('active');
//         document.querySelector('.project__form').classList.add('show');
//         document.querySelector('.project').classList.add('active');
//         mobileButton.classList.add('active');

//         if(document.querySelector('.menu-item-home').classList.contains('active')){
//             document.querySelector('.menu-item-home').classList.remove('active');
//             document.querySelector('.menu__border').style.transform = 'translateX(33vw)';
//         }

//         if(document.querySelector('.menuhamb').classList.contains('active')){
//             document.querySelector('.menuhamb').classList.remove('active');
//             document.querySelector('.menu__border').style.transform = 'translateX(33vw)';
//             document.querySelector('.menuPrincipalMobile').classList.remove('showMenu');
//         }
//     }
    
//     if(document.querySelector('.header__navigation').classList.contains('active')){
//         document.querySelector('.header__navigation').classList.remove('active');
//         document.querySelector('.header__mobile-hamb').classList.remove('active');
//     }
// })

buttonTemporaire1?.addEventListener('click', function(e){

    e.preventDefault()
    document.querySelector('.project__button').classList.toggle('active');
    document.querySelector('.project__form').classList.toggle('show');
    document.querySelector('.project').classList.toggle('active');


    if(document.querySelector('.header__navigation').classList.contains('active')){
        document.querySelector('.header__navigation').classList.remove('active');
        document.querySelector('.header__mobile-hamb').classList.remove('active');
        enableScroll()
    }

    if(document.querySelector('.menuPrincipalMobile').classList.contains('showMenu')){
        document.querySelector('.menuPrincipalMobile').classList.remove('showMenu');
        document.querySelector('.header__mobile-hamb').classList.remove('active');
        enableScroll()
    }
})

buttonTemporaire2?.addEventListener('click', function(e){

    e.preventDefault()

    document.querySelector('.project__button').classList.toggle('active');
    document.querySelector('.project__form').classList.toggle('show');
    document.querySelector('.project').classList.toggle('active');


    if(document.querySelector('.header__navigation').classList.contains('active')){
        document.querySelector('.header__navigation').classList.remove('active');
        document.querySelector('.header__mobile-hamb').classList.remove('active');
        enableScroll()
    }

    if(document.querySelector('.menuPrincipalMobile').classList.contains('showMenu')){
        document.querySelector('.menuPrincipalMobile').classList.remove('showMenu');
        document.querySelector('.header__mobile-hamb').classList.remove('active');
        enableScroll()
    }
})

buttonTemporaire3?.addEventListener('click', function(e){
    e.preventDefault()
    document.querySelector('.project__button').classList.toggle('active');
    document.querySelector('.project__form').classList.toggle('show');
    document.querySelector('.project').classList.toggle('active');


    if(document.querySelector('.header__navigation').classList.contains('active')){
        document.querySelector('.header__navigation').classList.remove('active');
        document.querySelector('.header__mobile-hamb').classList.remove('active');
        enableScroll()
    }

    if(document.querySelector('.menuPrincipalMobile').classList.contains('showMenu')){
        document.querySelector('.menuPrincipalMobile').classList.remove('showMenu');
        document.querySelector('.header__mobile-hamb').classList.remove('active');
        enableScroll()
    }
})

buttonTemporaire4?.addEventListener('click', function(e){
    e.preventDefault()
    document.querySelector('.project__button').classList.toggle('active');
    document.querySelector('.project__form').classList.toggle('show');
    document.querySelector('.project').classList.toggle('active');


    if(document.querySelector('.header__navigation').classList.contains('active')){
        document.querySelector('.header__navigation').classList.remove('active');
        document.querySelector('.header__mobile-hamb').classList.remove('active');
        enableScroll()
    }

    if(document.querySelector('.menuPrincipalMobile').classList.contains('showMenu')){
        document.querySelector('.menuPrincipalMobile').classList.remove('showMenu');
        document.querySelector('.header__mobile-hamb').classList.remove('active');
        enableScroll()
    }
})

function disableScroll() {
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.height = '100vh';
}

function enableScroll() {
    document.documentElement.style.overflow = '';
    document.documentElement.style.height = '';
}
